import React, { ReactPropTypes } from 'react'
import css from './card.module.scss'

export default ({ children }: React.PropsWithChildren) => (
  <div className={css.details}>
    <table>
      <tbody>{children}</tbody>
    </table>
  </div>
)
